module.exports = __webpack_public_path__ + "src/assets/img/checkmark_round.4604de81.svg";